import React from 'react'
import addSalary from "../../../../assets/images/employee/add-salary.png"
import { getVariablePayComponentValue } from '../../../employee/employee-details/employee-profile/layout/salary-component/salaryUtils';


const UserSalaryComponent = (props: any) => {
  const { showNull, salaryParticulars, employeeContribution, grossSalary, costToCompany, netAmount, combineEmployerArray } = props;
  const changeNumberToIndianCurrency = (numberValue: any) => {

    return Number(numberValue).toLocaleString('en-IN');
  }
  const variablePay = getVariablePayComponentValue(salaryParticulars);

  return (
    <>
      {showNull !== null && salaryParticulars.length > 0 && combineEmployerArray.length > 0 || employeeContribution.length > 0 ? (
        <div className="salary_prticulars-container pl-0 ">
          <div className="salary_prticulars-list overflow-auto lg:overflow-hidden lg:hover:overflow-y-auto mt-4">
            <div className="salary-structure grid grid-cols-3 gap-4 mb-4">
              <div className="particulars">
                <p className='_header mb-5'>Salary Particulars</p>
                <ul>
                  {salaryParticulars
                    .filter((item: any) => !(item.salaryComponentId === 132 && item?.name === 'LTA' && grossSalary?.grossAmountMonthly <= 36803) && item?.name !== 'Variable Pay')
                    .map((item: any) => (
                      <li key={item?.salaryComponentId}>{item?.name}</li>
                    ))}
                </ul>
                <p className='salary-gross'>Gross Salary</p>
              </div>
              <div className="monthly_details">
                <p className='_monthly'>Monthly</p>
                <ul>
                  {salaryParticulars
                    .filter((item: any) => !(item.salaryComponentId === 132 && item?.name === 'LTA' && grossSalary?.grossAmountMonthly <= 36803) && item?.name !== 'Variable Pay')
                    .map((item: any) => (
                      <li key={item?.salaryComponentId}>
                        &#8377;{item?.monthly !== '' ? changeNumberToIndianCurrency(item?.monthly) : 0}
                      </li>
                    ))}
                </ul>
                <div className='form-item basicForm-fields' >

                  <p className=' font-normal lg:font-bold font-rubik'> &#8377; {changeNumberToIndianCurrency(grossSalary?.grossAmountMonthly)}</p>
                </div>
              </div>
              <div className="annual_details">
                <p className='_annual'>Annual </p>
                <ul>
                  {salaryParticulars
                    .filter((item: any) => !(item.salaryComponentId === 132 && item?.name === 'LTA' && grossSalary?.grossAmountMonthly <= 36803) && item?.name !== 'Variable Pay')
                    .map((item: any) => (
                      <li key={item?.salaryComponentId}>
                        &#8377;{item?.yearly !== '' ? changeNumberToIndianCurrency(item?.yearly) : 0}
                      </li>
                    ))}
                </ul>
                <div className='form-item basicForm-fields' >

                  <p className='font-normal lg:font-bold font-rubik'> &#8377; {changeNumberToIndianCurrency(grossSalary?.grossAmountAnnual)}</p>
                </div>
              </div>
            </div>

            <div className='_header mb-5'>Employer Contribution</div>
            <div className="salary-structure grid grid-cols-3 gap-4 employee-salary-structure-row">
              <div className="particulars">
                <ul>
                  {combineEmployerArray.map((item: any) => (
                    <li key={item?.salaryComponentId}>{item?.name}</li>
                  ))}
                </ul>
                {
                  variablePay !== 0 && <div className='mb-5'>
                    <p className='font-medium font-rubik text-[#d34a7c]'>Variable Pay		</p>
                    <p className='italic text-[13px]'>Performance Bonus (Annual)</p>
                  </div>
                }
                <p className='salary-gross'>Cost To Company</p>

              </div>
              <div className="particulars">
                <ul>
                  {combineEmployerArray.map((item: any) => (
                    <li key={item?.salaryComponentId}>&#8377;{changeNumberToIndianCurrency(item?.monthly)}</li>
                  ))}
                </ul>
                {
                  variablePay !== 0 && <div className='variable-pay-details'><p className=''>-</p> </div>
                }
                <div className='variable-pay-details'>
                  <p className='salary-gross'>&#8377; {changeNumberToIndianCurrency(costToCompany?.ctcMonthly)}</p>
                </div>
              </div>
              <div className="particulars">
                <ul>
                  {combineEmployerArray.map((item: any) => (
                    <li key={item?.salaryComponentId}>&#8377;{changeNumberToIndianCurrency(item?.yearly)}</li>
                  ))}
                </ul>
                {
                  variablePay !== 0 && <div className='variable-pay-details'><p className='salary-gross'>
                    ₹{variablePay}
                  </p>
                  </div>
                }

                <div className='variable-pay-details'><p className='salary-gross' >&#8377;{changeNumberToIndianCurrency(Math.round(costToCompany?.ctcYearly + variablePay))} </p></div>
              </div>
            </div>
            <div className='_header mb-5'>Employee Contribution</div>
            <div className="salary-structure grid grid-cols-3 gap-4 mb-8">
              <div className="particulars">
                <ul>
                  {employeeContribution.map((item: any) => (
                    <li key={item?.salaryComponentId}>{item?.name}</li>
                  ))}
                </ul>
                <p className='salary-gross'>Net Salary</p>
              </div>
              <div className="particulars">
                <ul>
                  {employeeContribution.map((item: any) => (
                    <li key={item?.salaryComponentId}>&#8377;{changeNumberToIndianCurrency(item?.monthly)}</li>
                  ))}

                </ul>
                <p className='salary-gross'>&#8377; {changeNumberToIndianCurrency(netAmount?.monthly)}</p>
              </div>
              <div className="particulars">
                <ul>
                  {employeeContribution.map((item: any) => (
                    <li key={item?.salaryComponentId}>&#8377;{changeNumberToIndianCurrency(item?.yearly)}</li>
                  ))}
                </ul>
                <p className='salary-gross' >&#8377; {changeNumberToIndianCurrency(netAmount?.yearly)}</p>
              </div>
            </div>
          </div>
        </div>) : (
        <div className='h-[60vh] flex justify-center items-center'>
          <img src={addSalary} alt="" />
        </div>
      )}
    </>
  )
}

export default UserSalaryComponent
